import { useState } from "react";
import { CardFlipContainer, UserCardWrapper } from "./styles";
import UserInfo from "./user-info";
import UserWallet from "./user-wallet";
import UserCardSkeleton from "./skeleton";

interface UserCardProps {
  loading?: boolean;
  isQrOpen: boolean;
  setIsQrOpen: (isQrOpen: boolean) => void;
  qrValue: string;
}

const UserCard = ({
  loading = false,
  isQrOpen,
  setIsQrOpen,
  qrValue,
}: UserCardProps) => {
  const [isInfo, setIsInfo] = useState(false);
  const onClickInfo = () => {
    setIsInfo(!isInfo);
  };

  const onClickQr = () => {
    setIsQrOpen(!isQrOpen);
  };

  // 로딩 중일 때 스켈레톤 표시
  if (loading) {
    return null;
  }

  return (
    <UserCardWrapper>
      <CardFlipContainer isFlipped={isInfo}>
        <UserInfo
          onClickInfo={onClickInfo}
          onClickQr={onClickQr}
          qrValue={qrValue}
        />
        <UserWallet
          onClickInfo={onClickInfo}
          onClickQr={onClickQr}
          qrValue={qrValue}
        />
      </CardFlipContainer>
    </UserCardWrapper>
  );
};

export default UserCard;
